export default "__VITE_ASSET__acfd384a__"